module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gG5UT"))).then(() => parcelRequire('ljYL6'));